<div class="loading-indicator loader-hbs loading-hbs"><div class="loader-w"></div></div>